module.exports = __webpack_public_path__ + "media/categories/6011-c9f3c253.svg";